var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowStatus)?_c('span',{staticClass:"kiwi-awaystatusindicator",class:{ 'kiwi-awaystatusindicator--away': _vm.user && _vm.user.isAway(),
              'kiwi-awaystatusindicator--self': _vm.isUserSelf },on:{"click":function($event){return _vm.toggleSelfAway()}}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e0adb34","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AwayStatusIndicator.vue
// module id = bfc6
// module chunks = 1